import { MutationTree, ActionTree, GetterTree, Module } from 'vuex';
import { RootState, BucketsState, Bucket, BucketMap } from './../types';
import FRTBApi from '@/api/frtb.api';
import _ from 'lodash';
import Env from '@/services/env.service';

const state: BucketsState = {
  attributeIdUnderEdit: undefined,
  selectedBucketing: {},
  customBuckets: []
};

const fallbackBucket: Bucket = {
  id: 'Fallback',
  type: 'regulatory',
  value: [0, 1.5, 3.5, 7.5, 15]
};

const getters: GetterTree<BucketsState, RootState> = {
  getAttributeIdUnderEdit(bucketsState: BucketsState): string | undefined {
    return bucketsState.attributeIdUnderEdit;
  },
  getBucketingForAttribute(bucketsState, bucketsGetters, rootState): Function {
    return (attributeId: string): Bucket => {
      let bucket: Bucket = bucketsState.selectedBucketing[attributeId];

      if (bucket == null) {
        if (rootState.selections.selectedProducts) {
          // Attempt to get default bucketing strategy
          const length = rootState.selections.selectedProducts.length;
          for (let i = 0; i < length; i++) {
            const productId: string = rootState.selections.selectedProducts[i];
            if (rootState.options.productsById[productId]
              && rootState.options.productsById[productId].default_bucketing_set) {
                const bucketId = rootState.options.productsById[productId].default_bucketing_set;
                bucket = {
                  type: 'regulatory',
                  id: bucketId,
                  value: rootState.options.options.default_bucketing_sets[bucketId] || []
                };
            }
          }
        } else {
          bucket = fallbackBucket;
        }
      }

      return _.cloneDeep(bucket);
    };
  }
};

const mutations: MutationTree <BucketsState> = {
  setAttributeIdUnderEdit(bucketsState: BucketsState, attributeId: string): void {
    bucketsState.attributeIdUnderEdit = attributeId;
  },
  setSelectedBucketing(bucketsState: BucketsState, payload: { id: string, bucket: Bucket }): void {
    bucketsState.selectedBucketing = { ...bucketsState.selectedBucketing, [payload.id]: payload.bucket };
  },
  setCustomBuckets(bucketsState, customBuckets = []) {
    bucketsState.customBuckets = customBuckets;
  },
  resetAllBuckets(bucketsState: BucketsState): void {
    bucketsState.selectedBucketing = {};
  },
  removeCustomBucket(bucketsState, bucketId: string = '') {
    if (!bucketsState.customBuckets || (bucketsState.customBuckets && !bucketsState.customBuckets.length)) {
      return;
    }
    const index: number = bucketsState.customBuckets.findIndex( (bucket: any) => bucket.id === bucketId);
    const arr = bucketsState.customBuckets ? bucketsState.customBuckets.slice() : [];
    arr.splice(index, 1);
    bucketsState.customBuckets = arr;
  },
  addCustomBucketToStoreIfUnique(bucketsState, customBucket?) {
    if (customBucket && !bucketsState.customBuckets.find((b: any) => b.id === customBucket.id)) {
      bucketsState.customBuckets = bucketsState.customBuckets.concat(customBucket);
    }
  }
};

const actions: ActionTree <BucketsState, RootState> = {
  async getCustomBuckets(context) {
    const res = await FRTBApi.getCustomBuckets();
    context.commit('setCustomBuckets', res);
    return context.state.customBuckets;
  },
  async saveCustomBucket(context, customBucket) {
    try {
      const res = await FRTBApi.saveCustomBucket(customBucket);
      if (res.buckets) {
        context.commit('setCustomBuckets', res.buckets);
      }
      return res;
    } catch (e) {
      console.log(e);
    }
  },
  async deleteCustomBucket(context, customBucketId) {
    try {
      const res = await FRTBApi.deleteCustomBucket(customBucketId);
      context.commit('removeCustomBucket', customBucketId);
      return res;
    } catch (e) {
      console.log(e);
    }
  }
};

export const buckets: Module<BucketsState, RootState> = {
  state,
  mutations,
  getters,
  actions
};
